module.exports = __webpack_public_path__ + "img/governance-banner7.d3db5559.png";